import { Component, Input } from '@angular/core';
import { ApexResponsive, ApexNonAxisChartSeries, ApexChart, ApexDataLabels, ApexLegend, ApexFill, ApexTitleSubtitle } from "ng-apexcharts";
import { Helper } from '../../utilities/classes/helper.class';

@Component({
  selector: 'app-acc-piechart',
  templateUrl: './acc-piechart.component.html',
  styleUrls: ['./acc-piechart.component.scss']
})
export class AccPiechartComponent {
  @Input('properties') public properties: PieChartOptions = this.defaultPieChartOptions();

  constructor() { }

  public defaultPieChartOptions(): PieChartOptions {
    return Helper.chartOptions.pie;
  }

}

export interface PieChartOptions {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  fill: ApexFill;
  legend: ApexLegend;
  dataLabels: ApexDataLabels;
  title: ApexTitleSubtitle;
  colors: string[];
};
